import { render } from "./StudentDeviceRgistration.vue?vue&type=template&id=27da13ca&scoped=true"
import script from "./StudentDeviceRgistration.vue?vue&type=script&lang=js"
export * from "./StudentDeviceRgistration.vue?vue&type=script&lang=js"

import "./StudentDeviceRgistration.vue?vue&type=style&index=0&id=27da13ca&scoped=true&lang=scss"

import exportComponent from "C:\\prathamesh\\mahajyoti_admin_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27da13ca"]])

export default __exports__